import { axiosDefaultConfig } from 'constants/axios'
import {
  CampaignProgramListResponseItem,
  CampaignsApi,
  Configuration,
  Mill,
  MillsApi,
} from 'generated/api'
import { useEffect, useRef, useState } from 'react'

const axiosConfig = new Configuration(axiosDefaultConfig)
const millsApi = new MillsApi(axiosConfig)
const campaignsApi = new CampaignsApi(axiosConfig)

export const useCampaignList = () => {
  const hasMounted = useRef(false)
  const [status, setStatus] = useState('')
  const [mills, setMills] = useState<Mill[]>([])
  const [listDataProgram, setListDataProgram] = useState<CampaignProgramListResponseItem[]>([])

  const programData = [
    { key: 1, label: 'Semua Program', value: 0 },
    { key: 2, label: 'Panen Emas v1.0', value: 1 },
    { key: 3, label: 'Panen Emas v2.0', value: 2 },
  ]

  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [version, setVersion] = useState(0)
  const [partnerId, setPartnerId] = useState('0')
  const [totalRows, setTotalRows] = useState(0)

  useEffect(() => {
    getMills()
  }, [])

  useEffect(() => {
    fetchListProgram()
  }, [page, limit])

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true
    } else {
      filterProgram()
    }
  }, [partnerId, version])

  const filterProgram = () => {
    page === 1 ? fetchListProgram() : setPage(1)
  }
  const fetchListProgram = async () => {
    try {
      setStatus('LOADING')
      const { data } = await campaignsApi.campaignsProgramsGetList(
        partnerId !== '0' ? partnerId : '',
        version == 0 ? undefined : version,
        page,
        limit,
      )
      setListDataProgram(data.items)
      setTotalRows(data.pagination?.total || 0)
      setStatus('')
    } catch {
      setStatus('FAILED')
    }
  }

  const getMills = async () => {
    try {
      setStatus('LOADING')
      const { data } = await millsApi.getMills('ADMIN_WEB', '', true)
      setMills([
        {
          id: '0',
          name: 'Semua Pabrik',
          latitude: 0,
          longitude: 0,
          isPartner: false,
          prefixTicketNumber: '',
        },
        ...data.items,
      ])
      setStatus('')
    } catch {
      setStatus('FAILED')
    }
  }

  return {
    status,
    mills,
    setMills,
    getMills,
    fetchListProgram,
    listDataProgram,
    programData,
    limit,
    setLimit,
    page,
    setPage,
    version,
    setVersion,
    partnerId,
    setPartnerId,
    totalRows,
  }
}
